export default __webpack_public_path__ + "images/ok_c2b0a9.svg";